import React from "react";
import "../styles/buttons.scss";

/**
 * Button — MangoTV Design System
 * Figma: buttons component (24654:6048)
 * Primary: bg neutral/50 (#fafafa), text neutral/950, rounded-lg (8px)
 * Poppins SemiBold 18px/28px
 *
 * @param {string} label - Button text
 * @param {function} action - Click handler
 * @param {boolean} isLoading - Shows loading spinner
 * @param {boolean} isDisabled - Disabled state (opacity 0.4)
 * @param {string} variant - "primary" | "secondary" | "ghost"
 * @param {string} size - "lg" | "md" | "sm"
 * @param {string} className - Additional CSS classes
 */
const Button = ({
  label,
  action,
  isLoading = false,
  isDisabled = false,
  variant = "primary",
  size = "lg",
  className = "",
}) => {
  const handleClick = () => {
    if (!isLoading && !isDisabled && action) {
      action();
    }
  };

  return (
    <button
      className={`mango-btn mango-btn--${variant} mango-btn--${size} ${
        isDisabled ? "mango-btn--disabled" : ""
      } ${className}`}
      onClick={handleClick}
      disabled={isDisabled || isLoading}
    >
      {isLoading ? (
        <span className="mango-btn__loader" />
      ) : (
        <span className="mango-btn__label">{label}</span>
      )}
    </button>
  );
};

export default Button;
